// Lucide "tag" icon — https://lucide.dev/icons/tag (ISC License)
// Flipped horizontally to point right.

const TagIcon = ({ size = 24, color = "#FACC15", strokeWidth = 2, className = "", ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g transform="scale(-1, 1) translate(-24, 0)">
        <path
          d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="7.5" cy="7.5" r="0.5" fill="none" stroke={color} strokeWidth={strokeWidth} />
      </g>
    </svg>
  );
};

export default TagIcon;
